/**
 * Returns a safe, same-origin relative path for post-auth redirects.
 *
 * Prevents open-redirect by rejecting absolute URLs (http:, javascript:, etc.)
 * and protocol-relative paths (//evil.com). Anything not a clean internal path
 * falls back to the provided default (default: '/').
 */
export const safeInternalPath = (
  value: string | null | undefined,
  fallback = '/',
): string => {
  if (!value) return fallback;
  // Must start with a single '/', not '//' (protocol-relative) or '/\'.
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) {
    return fallback;
  }
  // Reject any embedded scheme/backslash tricks.
  if (/^[a-z][a-z0-9+.-]*:/i.test(value) || value.includes('\\')) {
    return fallback;
  }
  return value;
};
